import React from "react";

const BoldIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.5 3.16797H8.33333C9.71405 3.16797 10.8333 4.28726 10.8333 5.66797C10.8333 7.04868 9.71405 8.16797 8.33333 8.16797H4.5V3.16797Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 8.16797H9.16667C10.4553 8.16797 11.5 9.21264 11.5 10.5013C11.5 11.79 10.4553 12.8346 9.16667 12.8346H4.5V8.16797Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BoldIcon;
